import "./noData.scss";
import { NoData as NoDataShared } from "@shared/src";

interface NoDataProps {
  title: string | React.ReactNode;
  desc?: string | React.ReactNode;
  extra?: React.ReactNode;
  style?: React.CSSProperties;
  button?: {
    text: string;
    theme: "brown500" | "red-500";
    onClick: () => void;
  };
}

/**
 * 데이터 없음 컴포넌트
 *
 * @param title 제목
 * @param desc 설명
 * @param extra 추가 내용
 * @param style 스타일
 * @param button 버튼
 */
const NoData = ({ title, desc, extra, style, button }: NoDataProps) => {
  return (
    // <div className="no-data-wrap" style={style}>
    //   <i>😢</i>
    //   <b>{title}</b>
    //   {desc && <p style={{whiteSpace: 'pre-line'}}>{desc}</p>}
    //   {extra && extra}
    // 	{button &&
    // 	<button className={`btn btn-small btn-${button.theme}`} onClick={button.onClick}>
    // 		{button.text}
    // 	</button>
    // 	}
    // </div>
    <NoDataShared title={title} desc={desc} extra={extra} style={style} icon="😢" />
  );
};

export default NoData;
